const axios = require('axios');

function processConvertItems(key, value) {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.readAsDataURL(value);
    reader.onload = () => resolve([key, reader.result]);
  });
}

export default class Requests {
  constructor(beforeRequest, afterRequest, onError) {
    const classObj = this;

    const defaultURL = process.env.BASE_URL;
    this.axios = axios.create({
      baseURL: defaultURL,
      timeout: 360 * 1000,
      headers: {
        'Content-Type': 'application/json',
      },
      withCredentials: true,
    });

    this.createCancelToken();

    function addHandler(key, handler) {
      if (typeof handler === 'function') {
        classObj[key] = handler;
      }
    }

    addHandler('beforeRequest', beforeRequest);
    addHandler('afterRequest', afterRequest);
    addHandler('onError', onError);
  }

  createCancelToken() {
    const cancelToken = axios.CancelToken;
    this.source = cancelToken.source();
  }

  cancelUploadRequest() {
    this.source.cancel('Request cancelled by user');
    this.createCancelToken();
  }

  executeBeforeRequest() {
    if (this.beforeRequest) {
      this.beforeRequest();
    }
  }

  executeAfterRequest() {
    if (this.afterRequest) {
      this.afterRequest();
    }
  }

  executeOnError(error) {
    let response = { data: { message: '' } };
    if (!error) {
      response.data.message = 'There was an error while trying to complete your request.';
    } else if (error.code === 'ECONNABORTED') {
      response.data.message = 'The request timed out.';
    } else if (error.response) {
      response = error.response;
    }

    if (this.onError) {
      this.onError(response);
    }

    return response;
  }

  request(config, handlerConfig) {
    const configRequest = {
      pre: !(handlerConfig && handlerConfig.pre === false),
      post: !(handlerConfig && handlerConfig.post === false),
      error: !(handlerConfig && handlerConfig.error === false),
    };

    if (configRequest.pre) {
      this.executeBeforeRequest();
    }
    return new Promise((resolve, reject) => {
      this.axios.request(config)
        .then((response) => {
          this.executeAfterRequest();
          resolve(response);
        })
        .catch((error) => {
          this.executeAfterRequest();
          reject(configRequest.error !== false ? this.executeOnError(error) : error);
        });
    });
  }

  get(url, params, handlerConfig) {
    const config = { url, method: 'get' };

    if (params) {
      config.params = params;
    }

    return this.request(config, handlerConfig);
  }

  post(url, data, handlerConfig) {
    const config = { url, data, method: 'post' };
    return this.request(config, handlerConfig);
  }

  delete(url, handlerConfig) {
    const config = { url, method: 'delete' };
    return this.request(config, handlerConfig);
  }

  async upload(url, data, callbackProgress, handlerConfig) {
    const jsonData = {};
    /* eslint-disable-next-line no-restricted-syntax */
    for (const key of Object.keys(data)) {
      if (data[key] instanceof File) {
        /* eslint-disable no-await-in-loop */
        const [fileKey, fileBase64Str] = await processConvertItems(key, data[key]);
        jsonData[fileKey] = fileBase64Str;
        jsonData[`${key}-filename`] = data[key].name;
      } else {
        jsonData[key] = data[key];
      }
    }
    const jsonString = JSON.stringify(jsonData);

    const config = {
      headers: { 'Content-Type': 'application/json' },
      cancelToken: this.source.token,
      url,
      data: jsonString,
      method: 'post',
      onUploadProgress: (progressEvent) => {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        if (callbackProgress) {
          callbackProgress(percentCompleted);
        }
      },
    };
    return this.request(config, handlerConfig);
  }

  async uploadAssetManagement(url, data, callbackProgress, handlerConfig) {
    const jsonData = {};
    const fileList = [];
    /* eslint-disable-next-line no-restricted-syntax */
    for (const key of Object.keys(data)) {
      if (data[key] instanceof File) {
        /* eslint-disable no-await-in-loop */
        // eslint-disable-next-line no-unused-vars
        const [fileKey, fileBase64Str] = await processConvertItems(key, data[key]);
        const file = {};
        file.file = fileBase64Str;
        file['file-filename'] = data[key].name;
        fileList.push(file);
      } else {
        jsonData[key] = data[key];
      }
    }
    jsonData.files = fileList;
    const jsonString = JSON.stringify(jsonData);
    const config = {
      headers: { 'Content-Type': 'application/json' },
      cancelToken: this.source.token,
      url,
      data: jsonString,
      method: 'post',
      onUploadProgress: (progressEvent) => {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        if (callbackProgress) {
          callbackProgress(percentCompleted);
        }
      },
    };
    return this.request(config, handlerConfig);
  }
  async uploadMultipleFiles(url, data, callbackProgress, handlerConfig) {
    const jsonData = {};
    const fileList = [];
    /* eslint-disable-next-line no-restricted-syntax */
    for (const key in data.files) {
      if (data.files[key] instanceof File) {
        /* eslint-disable no-await-in-loop */
        // eslint-disable-next-line no-unused-vars
        const [fileKey, fileBase64Str] = await processConvertItems(key, data.files[key]);
        const file = {};
        file.file = fileBase64Str;
        file['file-filename'] = data.files[key].name;
        fileList.push(file);
      } else {
        jsonData[key] = data.files[key];
      }
    }
    jsonData.files = fileList;
    jsonData.type = data.type;
    const jsonString = JSON.stringify(jsonData);
    const config = {
      headers: { 'Content-Type': 'application/json' },
      cancelToken: this.source.token,
      url,
      data: jsonString,
      method: 'post',
      onUploadProgress: (progressEvent) => {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        if (callbackProgress) {
          callbackProgress(percentCompleted);
        }
      },
    };
    return this.request(config, handlerConfig);
  }
}



// WEBPACK FOOTER //
// ./src/requests/requests.js